module.exports = __webpack_public_path__ + "static/absence-of-mind-bf5389d334bc2bedccb64737dfb7a29d.jpg";